"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Context = void 0;
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Context = /** @class */ (function () {
    /**
     * Construct a new context which inherits values from an optional parent context.
     *
     * @param parentContext a context from which to inherit values
     */
    function Context(parentContext) {
        this._currentContext = parentContext ? new Map(parentContext) : new Map();
    }
    /** Get a key to uniquely identify a context value */
    Context.createKey = function (description) {
        return Symbol(description);
    };
    /**
     * Get a value from the context.
     *
     * @param key key which identifies a context value
     */
    Context.prototype.getValue = function (key) {
        return this._currentContext.get(key);
    };
    /**
     * Create a new context which inherits from this context and has
     * the given key set to the given value.
     *
     * @param key context key for which to set the value
     * @param value value to set for the given key
     */
    Context.prototype.setValue = function (key, value) {
        var context = new Context(this._currentContext);
        context._currentContext.set(key, value);
        return context;
    };
    /**
     * Return a new context which inherits from this context but does
     * not contain a value for the given key.
     *
     * @param key context key for which to clear a value
     */
    Context.prototype.deleteValue = function (key) {
        var context = new Context(this._currentContext);
        context._currentContext.delete(key);
        return context;
    };
    /** The root context is used as the default parent context when there is no active context */
    Context.ROOT_CONTEXT = new Context();
    /**
     * This is another identifier to the root context which allows developers to easily search the
     * codebase for direct uses of context which need to be removed in later PRs.
     *
     * It's existence is temporary and it should be removed when all references are fixed.
     */
    Context.TODO = Context.ROOT_CONTEXT;
    return Context;
}());
exports.Context = Context;
//# sourceMappingURL=context.js.map